import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_TYPE = {
	name: "OBSERVATION_TYPE",
	concept: {
		FALL: {
			display: {
				"nl-BE": "Val",
				"fr-BE": "Chute",
			},
		},
		INCONTINENCE: {
			display: {
				"nl-BE": "Incontinentie",
				"fr-BE": "Incontinence",
			},
		},
		URINE: {
			display: {
				"nl-BE": "Urine-incontinentie",
				"fr-BE": "Incontinence urinaire",
			},
		},
		FECAL: {
			display: {
				"nl-BE": "Fecale incontinentie",
				"fr-BE": "Incontinence fécale",
			},
		},
		URINE_AND_FECAL: {
			display: {
				"nl-BE": "Urine & fecale incontinentie",
				"fr-BE": "Incontinence urinaire & fécale",
			},
		},
		INFECTION: {
			display: {
				"nl-BE": "Vermoeden van infectie",
				"fr-BE": "Suspicion d'infection",
			},
		},
		ALLERGY: {
			display: {
				"nl-BE": "Allergie",
				"fr-BE": "Allergie",
			},
		},
		CONTENTION: {
			display: {
				"nl-BE": "Fixatie",
				"fr-BE": "Contention",
			},
		},
		EVALUATION: {
			display: {
				"nl-BE": "Evaluatie",
				"fr-BE": "Évaluation des risques",
			},
		},
		FUGUE: {
			display: {
				"nl-BE": "Vluchtgedrag",
				"fr-BE": "Fugue",
			},
		},
		BEHAVIOUR: {
			display: {
				"nl-BE": "Gedrag",
				"fr-BE": "Trouble de comportement",
			},
		},
		OTHER: {
			display: {
				"nl-BE": "Andere",
				"fr-BE": "Autre",
			},
		},
		PHYSICAL_COMPLAINT: {
			display: {
				"nl-BE": "Fysieke klachten",
				"fr-BE": "Plaintes physiques",
			},
		},
		NUTRITION_AND_HYDRATION: {
			display: {
				"nl-BE": "Voeding & hydratatie",
				"fr-BE": "Alimentation & hydratation",
			},
		},
	},
} as const satisfies CodeSystem;
